import { tv } from '@change/ds-utils';

export const shareVisualItemStyles = tv({
	base: 'mb-8 mt-6 box-border snap-start first:ml-4 last:mr-4 md:m-0 md:mt-6 md:first:ml-0 md:last:mr-0',
	variants: {
		hasMany: {
			true: [
				// base
				'min-w-[219px] shrink-0 grow-0 basis-[219px] scroll-ml-[3px]',
				// md
				'md:min-w-0 md:shrink md:grow md:basis-[31%] md:scroll-ml-0',
				// lg
				'lg:basis-[22.5%]',
			],
			false: [
				// base
				'min-w-[219px] shrink-0 grow-0 basis-[219px] scroll-ml-[3px]',
				// md
				'md:min-w-0 md:shrink md:grow md:basis-1/2 md:scroll-ml-0',
				// lg
				'lg:basis-1/2',
			],
		},
	},
});
